export const escapePathForURL = path =>{
  if(path.includes("?")){
    path = (path).replace('?', encodeURIComponent('?'))
  }
  return path
}